export default "__VITE_PUBLIC_ASSET__4154dab2__"